<div class="adm-page">
  <header class="adm-page__header">
    <div class="adm-page__header-left">
      <div class="adm-page__icon">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <polyline points="23 4 23 10 17 10" />
          <polyline points="1 20 1 14 7 14" />
          <path
            d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"
          />
        </svg>
      </div>
      <div>
        <h1 class="adm-page__title">Synchronisation</h1>
        <p class="adm-page__desc">
          Synchronisez les comptes entre Keycloak et la base SIMO.
        </p>
      </div>
    </div>

    <div class="sync-appid-badge">
      <span class="sync-appid-badge__label">Application ID</span>
      <span class="sync-appid-badge__value">{{ applicationId || "—" }}</span>
    </div>
  </header>

  <!-- ── Actions Import / Export ── -->
  <div class="sync-actions">
    <div class="adm-card sync-action-card">
      <div class="sync-action-card__body">
        <div class="sync-action-card__head">
          <div class="sync-action-card__icon">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
          </div>
          <div>
            <p class="sync-action-card__title">Import KC → BDD</p>
            <p class="sync-action-card__subtitle">
              Keycloak est la source de vérité
            </p>
          </div>
        </div>
        <p class="sync-action-card__desc">
          Importe les comptes Keycloak dans la base SIMO. Les comptes existants
          sont mis à jour, les nouveaux sont créés.
        </p>
        <app-ui-button
          [label]="
            running === 'import' ? 'Import en cours…' : 'Lancer l\'import'
          "
          variant="primary"
          size="md"
          type="button"
          [disabled]="!!running"
          [loading]="running === 'import'"
          (clicked)="lancerImport()"
        >
        </app-ui-button>
      </div>
    </div>

    <div class="adm-card sync-action-card">
      <div class="sync-action-card__body">
        <div class="sync-action-card__head">
          <div class="sync-action-card__icon sync-action-card__icon--success">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
              <polyline points="17 8 12 3 7 8" />
              <line x1="12" y1="3" x2="12" y2="15" />
            </svg>
          </div>
          <div>
            <p class="sync-action-card__title">Export BDD → KC</p>
            <p class="sync-action-card__subtitle">
              La BDD SIMO est la source de vérité
            </p>
          </div>
        </div>
        <p class="sync-action-card__desc">
          Exporte les utilisateurs SIMO vers Keycloak. Les comptes absents sont
          créés avec un mot de passe temporaire.
        </p>
        <app-ui-button
          [label]="
            running === 'export' ? 'Export en cours…' : 'Lancer l\'export'
          "
          variant="primary"
          size="md"
          type="button"
          [disabled]="!!running"
          [loading]="running === 'export'"
          (clicked)="lancerExport()"
        >
        </app-ui-button>
      </div>
    </div>
  </div>

  <!-- ── Progression ── -->
  @if (running || statut) {
    <div class="adm-card sync-progress-card">
      <div class="sync-progress-card__head">
        <div class="sync-progress-card__title-group">
          <span class="sync-progress-card__title">
            {{
              running === "import" || statut?.jobId?.includes("import")
                ? "Import KC → BDD"
                : "Export BDD → KC"
            }}
          </span>
          @if (statut) {
            <span
              class="sync-status-badge"
              [class]="'sync-status-badge--' + statut.statut.toLowerCase()"
            >
              {{ statut.statut }}
            </span>
          }
        </div>
        @if (running) {
          <app-ui-button
            label="Arrêter le suivi"
            variant="ghost"
            size="sm"
            type="button"
            (clicked)="annulerSuivi()"
          ></app-ui-button>
        }
      </div>

      @if (statut) {
        <div class="sync-counters">
          <div class="sync-counter sync-counter--success">
            <p class="sync-counter__value">{{ statut.succes }}</p>
            <p class="sync-counter__label">Succès</p>
          </div>
          <div class="sync-counter sync-counter--danger">
            <p class="sync-counter__value">{{ statut.echecs }}</p>
            <p class="sync-counter__label">Échecs</p>
          </div>
          <div class="sync-counter">
            <p class="sync-counter__value">{{ progressPercent }}%</p>
            <p class="sync-counter__label">Progression</p>
          </div>
        </div>
      }

      <div class="sync-progress-bar">
        <div
          class="sync-progress-bar__fill"
          [class]="
            running
              ? 'sync-progress-bar__fill--running'
              : statut?.statut === 'TERMINE'
                ? 'sync-progress-bar__fill--done'
                : 'sync-progress-bar__fill--error'
          "
          [style.width.%]="running ? 100 : progressPercent"
        ></div>
      </div>

      @if (statut?.details?.length) {
        <div class="sync-errors">
          <p class="sync-errors__title">
            {{ statut!.details.length }} erreur{{
              statut!.details.length !== 1 ? "s" : ""
            }}
            rencontrée{{ statut!.details.length !== 1 ? "s" : "" }}
          </p>
          <div class="sync-errors__list">
            @for (e of statut!.details; track e) {
              <p class="sync-errors__item">{{ e }}</p>
            }
          </div>
        </div>
      }
    </div>
  }

  <!-- ── Historique ── -->
  <div class="adm-card sync-history-card">
    <div class="adm-card__toolbar">
      <div class="adm-card__toolbar-left">
        <p class="sync-history-card__title">Historique des synchronisations</p>
        @if (jobs.length) {
          <span class="adm-badge">{{ jobs.length }}</span>
        }
      </div>
      <app-ui-button
        label="Actualiser"
        variant="ghost"
        size="sm"
        type="button"
        [disabled]="loadingJobs"
        (clicked)="loadJobs()"
      ></app-ui-button>
    </div>

    @if (loadingJobs) {
      <div class="adm-loader-wrapper">
        <app-loader
          spinnerColor="#fff"
          baseColor="rgba(0,0,0,0.1)"
          loaderSize="28px"
        ></app-loader>
      </div>
    } @else if (!jobs.length) {
      <div class="adm-empty">
        <div class="adm-empty__icon">
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>
        <p class="adm-empty__title">Aucune synchronisation</p>
        <p class="adm-empty__hint">
          L'historique apparaîtra ici après le premier import ou export.
        </p>
      </div>
    } @else {
      <div class="sync-history-list">
        @for (job of jobs; track job.jobId) {
          <div class="sync-history-item">
            <div class="sync-history-item__info">
              <p class="sync-history-item__id">{{ job.jobId }}</p>
              <p class="sync-history-item__meta">
                <span class="sync-history-item__succes"
                  >{{ job.succes }} succès</span
                >
                &nbsp;·&nbsp;
                <span class="sync-history-item__echecs"
                  >{{ job.echecs }} échec{{ job.echecs !== 1 ? "s" : "" }}</span
                >
              </p>
            </div>
            <span
              class="sync-status-badge"
              [class]="'sync-status-badge--' + job.statut.toLowerCase()"
            >
              {{ job.statut }}
            </span>
          </div>
        }
      </div>
    }
  </div>
</div>

@if (showAlert) {
  <div class="sync-toast" [class]="'sync-toast--' + alertType">
    <span>{{ alertMessage }}</span>
    <button type="button" class="sync-toast__close" (click)="dismissAlert()">
      ✕
    </button>
  </div>
}
